import React from 'react';
import { Formik } from 'formik';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import Selector from 'react-select';
import { FaSearch } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

export default function FiltrosRelatorio({
  onSubmit,
  isLoading,
  dadosIniciais,
  isLoadingIniciais,
}) {
  const optionsEmps = ((dadosIniciais && dadosIniciais.empreendimentos) || []).map(item => ({
    value: item.codigo,
    label: item.descricao,
  }));

  const initialValues = {
    codigo_familia: (dadosIniciais && dadosIniciais.codigo_familia_lancamento) || null,
    data_inicial: '',
    data_final: '',
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="align-items-end mb-2">
                <Col xs={12} md={4}>
                  <Form.Group>
                    <Form.Label>Empreendimento:</Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      options={optionsEmps}
                      isClearable
                      placeholder="Selecione um empreendimento..."
                      value={optionsEmps.find(o => o.value === values.codigo_familia) || null}
                      onChange={option =>
                        setFieldValue('codigo_familia', option ? option.value : null)
                      }
                      noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group>
                    <Form.Label>De:</Form.Label>
                    <Form.Control
                      type="date"
                      value={values.data_inicial}
                      onChange={e => setFieldValue('data_inicial', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group>
                    <Form.Label>Ate:</Form.Label>
                    <Form.Control
                      type="date"
                      value={values.data_final}
                      onChange={e => setFieldValue('data_final', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group>
                    <Button
                      type="submit"
                      variant="success"
                      block
                      disabled={isLoading || isLoadingIniciais}
                    >
                      <FaSearch /> Mostrar Dashboard
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
}
